import { useEffect } from 'react';
import { useWorkClockContext } from '../context/WorkClockContext';

export const formatElapsed = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return [hours, minutes, seconds].map((n) => String(n).padStart(2, '0')).join(':');
};

const useWorkClock = ({ logLimit = 20, loadLogs = true } = {}) => {
  const context = useWorkClockContext();
  const { fetchLogs } = context;

  useEffect(() => {
    if (loadLogs) {
      fetchLogs(logLimit);
    }
  }, [fetchLogs, loadLogs, logLimit]);

  return {
    ...context,
    handleClockIn: () => context.handleClockIn(logLimit),
    handlePause: () => context.handlePause(logLimit),
    handleResume: () => context.handleResume(logLimit),
    handleClockOut: () => context.handleClockOut(logLimit),
    refresh: context.fetchStatus,
  };
};

export default useWorkClock;
